import React from "react";
import { useNavigate } from "react-router-dom";


interface AddButtonProps {
  label?: string;
  onLoadingLabel?: string;
  to?: string;
  onClick?: any;
  className?: string;
  disabled?: boolean;
  bgColorClass?: string | null;
  style?: React.CSSProperties;
}

const PrimaryButton: React.FC<AddButtonProps> = ({
  onLoadingLabel,
  label = "Button Label",
  to = "/",
  onClick,
  className = "",
  disabled = false,
  bgColorClass = null
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(to);
    }
  };

  return (
    <button
      disabled={disabled}
      onClick={handleClick}
      className={`${bgColorClass ? bgColorClass : "bg-customOrange"} ${disabled ? "opacity-65 cursor-not-allowed" : "hover:bg-greenBg"}  text-white text-sm font-semibold px-4 py-1.5 rounded-md flex items-center justify-center ease-in-out duration-300 hover:shadow-[1px_2px_7px_rgba(0,112,112,0.8)] active:scale-90 hover:scale-105 ${className}`}
    >
      <span>{label}</span>
    </button>
  );
};

export default PrimaryButton;
